export default "__VITE_ASSET__fq5ABgwG__"